import CONFIG from 'config';
import * as Api from './api';
import * as Http from './http';
import { sleep } from './sleep';
import * as UserSettings from './user-settings';

const TAG = 'AUT3: ';

let isRefreshingToken = false;

export function isTokenValid(): boolean {
  return UserSettings.getToken() && !isTokenExpired();
}

export function isTokenExpired(): boolean {
  if (!UserSettings.getToken()) {
    return false;
  }

  return !(new Date() < new Date(UserSettings.getTokenExpire()));
}

export async function getToken(domain: string, code: string) {
  console.log(TAG, 'Retrieving token');

  const payload = {
    grant_type: 'authorization_code',
    client_id: CONFIG.auth.client_id,
    client_secret: CONFIG.auth.client_secret,
    code: code,
    redirect_uri: CONFIG.urls.form,
  };

  const response = await Http.postForm(domain + '/token', payload);

  console.log(TAG, 'Token retrieved ');

  UserSettings.setTokenExpire(response['.expires']);
  UserSettings.setToken(response['access_token']);
  UserSettings.setRefreshToken(response['refresh_token']);
}

export async function refreshToken() {
  console.log(TAG, 'Refreshing token for project ', UserSettings.getProject());

  while (isRefreshingToken) {
    console.log(TAG, 'Token refresh is in progress, waiting');
    await sleep(100);
  }

  isRefreshingToken = true;
  try {
    const payload = {
      grant_type: 'refresh_token',
      client_id: CONFIG.auth.client_id,
      client_secret: CONFIG.auth.client_secret,
      refresh_token: UserSettings.getRefreshToken(),
      redirect_uri: CONFIG.urls.form,
    };

    if (UserSettings.getProject()) {
      payload['ProjectIDs'] = UserSettings.getProject();
    }

    const response = await Http.postForm(
      UserSettings.getDomain() + '/token',
      payload
    );

    console.log(TAG, 'Token refreshed ');

    UserSettings.setTokenExpire(response['.expires']);
    UserSettings.setToken(response['access_token']);
    UserSettings.setRefreshToken(response['refresh_token']);
  } finally {
    isRefreshingToken = false;
  }
}

/** Retrieves client code and saves it to UserSettings */
export async function refreshClientCode() {
  try {
    const clientCode = await Api.getClientCode();
    console.log(TAG, 'Client code ', clientCode);
    UserSettings.setClientCode(clientCode);
  } catch (error) {
    console.log(TAG, 'Failed to retrieve client code. Not supported?', error);
  }
}
